import {createSlice} from '@reduxjs/toolkit';

const projectsSlice = createSlice({
    name: 'projects',
    initialState: [],
    reducers: {
        setProjects: (_, action) => action.payload,
        addProject: (state, action) => [...state, action.payload],
        updateProjectById: (state, action) =>
            state.map(p => p.id === action.payload.id ? action.payload : p),
        removeProjectById: (state, action) =>
            state.filter(p => p.id !== action.payload),
        removeProjectsByCompanyId: (state, action) =>
            state.filter(p => p.companyId !== action.payload),
    },
    selectors: {
        selectProjects: state => state,
    },
});

export const {
    setProjects,
    addProject,
    updateProjectById,
    removeProjectById,
    removeProjectsByCompanyId,
} = projectsSlice.actions;
export const {selectProjects} = projectsSlice.selectors;
export const {reducer} = projectsSlice;
